// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".batchAddFilesBox[data-v-6296a3a8]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}.batchAddFilesBox .el-upload__text[data-v-6296a3a8]{color:#888}.batchAddFilesBox[data-v-6296a3a8]  .el-upload-dragger{background:#fcfcfc}", ""]);
// Exports
module.exports = exports;
